// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1R7s_","consentsList":"PatientConsents_consentsList__34L5v","consentsListEmpty":"PatientConsents_consentsListEmpty__1MVaP"};